import Api from '@/api/api.js'

export default {
    
    /**
     * Route pour recuperer les bons commandes  
     */
    bonCommandes () {
        const promise = Api().get('/bon-commandes')
        return promise.then((response) => response.data)
    },

    /**
     * Enregistrer un bon de commandes
     * @param object data 
     */
    saveBonCommande (data) {
        const promise = Api().post('/bon-commande', data)
        return promise.then((response) => response.data)
    },

    /**
     * get un bon de commandes
     * @param id int
     */
    getBonCommande (id) {
        const promise = Api().get('/bon-commande/'+id)
        return promise.then((response) => response.data)
    },

    /**
     * delete un bon de commande
     * @param id int
     */
    deleteBonCommande (id) {
        const promise = Api().delete('/bon-commande/'+id)
        return promise.then((response) => response.data)
    },

    /**
     * delete un bon de commande
     * @param id int
     * @param data object
     * 
     */
    deleteArticleBonCommande (id, data) {
        const promise = Api().delete('/bon-commande/'+id, data)
        return promise.then((response) => response.data)
    },


    

  }